import ENV from "config/Env";
import { useTypedMutation } from "hooks";
import { ApiInstance } from "utils/Api";

export const useUploadDocumentationFileMutation = () =>
  useTypedMutation<File, string>({
    mutationFn: async file => {
      const formData = new FormData();
      formData.append("file", file);

      return (await ApiInstance.post("/documentations/upload", formData, ENV.dealerBaseURL)).data.url;
    },
    onSuccess: () => null
  });
